// extracted by mini-css-extract-plugin
export default {"bar":"LazyLoading_bar__1kQIF","loading-bar":"LazyLoading_loading-bar__gAdsV"};